const updateTemplate = (app, template) => {
  return app.view.templates.map(t =>
    t.id === template.id
    ? template
    : t
  );
};

export default updateTemplate;
